<template lang="pug">
.footer-nav 
  //- small {{ betparlayCount}}
  .paralay-selection-wrapper(v-if="betparlayCount > 0" @click="showMe()")
    .left
      .selection-wrap
        span {{ $t("ui.parlay_slip_selection")}}
        span.selection {{ betparlayCount }}
    .right
      .odds-wrap
        span {{ $t("ui.odds") }}:
        span.odds.ml-1  {{ multi }}
  .footer-wrapper
    router-link.footer-single(v-if="!whiteLabel" :class="{ 'active' : $route.name == 'lobby' }" to="/lobby")
      .footer-icon-wrap
        .footer-icon
          ThemeImage.custom-icon(src='images/light/footer-nav/home.svg')
        .footer-name {{ $t("ui.home") }}
    .footer-single.dropdown(:class="{ 'active' : $route.name == 'prematch' }")
      #btn-dd-prematch.footer-icon-wrap(data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
        .footer-icon
          ThemeImage.custom-icon(src='images/light/footer-nav/sports.svg')
        .footer-name {{ $t("ui.sports") }}
      ul.dropdown-menu(aria-labelledby='btn-dd-prematch')
        li.d-item(:class="[1,12].includes(menu2) ? 'active' : ''")
          template(v-if="$store.getters.currencyCode == 'BDT'")
            a(href="javascript:void(0);" @click="selectFooterSport(12)")
              ThemeImage.icon-prematch(:src="'/images/light/sport/white/' + getSportsImage(12)")
              | {{ $t("ui.cricket") }}
          template(v-else)
            a(href="javascript:void(0);" @click="selectFooterSport(1)")
              ThemeImage.icon-prematch(:src="'/images/light/sport/white/' + getSportsImage(1)")
              | {{ $t("ui.soccer") }}
        li.d-item(:class="menu2 == 2 ? 'active' : ''")
          a(href="javascript:void(0);" @click="selectFooterSport(2)")
            ThemeImage.icon-prematch(:src="'/images/light/sport/white/' + getSportsImage(2)")
            | {{ $t("ui.basketball") }}
        li.d-item(v-if="esports2" :class="menu2 == 20 ? 'active' : ''")
          router-link(to="/slots?mode=3" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
            ThemeImage.icon-prematch(:src="'/images/light/sport/white/' + getSportsImage(20)")
            | {{ $t("ui.esports2") }}
        li.d-item(:class="this.vg1.includes(menu2) ? 'active' : ''")
          a(href="javascript:void(0);" @click="selectFooterSport(57)")
            ThemeImage.icon-prematch(src='/images/light/sport/white/v-games.svg?v=12')
            | {{ $t("ui.egames") }}
        li.d-item(:class="menu2 == 7 ? 'active' : ''")
          a(href="javascript:void(0);" @click="selectFooterSport(7)")
            ThemeImage.icon-prematch(:src="'/images/light/sport/white/' + getSportsImage(7)")
            | {{ $t("ui.tennis") }}            
        li.d-item(:class="menu2 == 40 ? 'active' : ''")
          a(href="javascript:void(0);" @click="selectFooterSport(40)")
            ThemeImage.icon-prematch(:src="'/images/light/sport/white/' + getSportsImage(40)")
            | {{ $t("ui.fd") }}
        li.d-item
          a(data-bs-toggle='modal' data-bs-target='#allSport')
            ThemeImage.icon-prematch(:src="'images/light/sport/white/all-sport.svg'")
            | {{ $t("ui.all_sports") }}    
    template(v-if="!whiteLabel && !mmoMode && brand != 'IBCBET' && brand != 'UBETT'")      
      .footer-single.dropdown(:class="{ 'active' : ['mybets','my4dbets'].includes($route.name) }")
        #btn-dd-mybets.footer-icon-wrap(data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
          .footer-icon
            ThemeImage.custom-icon(src='images/light/footer-nav/mybet.svg')
          .footer-name {{ $t("ui.my_bets") }}
        ul.dropdown-menu(aria-labelledby='btn-dd-mybets')
          li.d-item(:class="$route.name == 'mybets' ? 'active' : ''")
            a(href="javascript:void(0);" @click="go('/mybets')")
              | {{ $t("ui.sportsbook") }}
          li.d-item(:class="$route.name == 'my4dbets' ? 'active' : ''")
            a(href="javascript:void(0);" @click="go('/my4dbets')")
              | {{ $t("ui.w4d") }}
    template(v-else)
      router-link.footer-single(:class="{ 'active' : $route.name == 'mybets' }" to="/mybets")
        .footer-icon-wrap
          .footer-icon
            ThemeImage.custom-icon(src='images/light/footer-nav/mybet.svg')
          .footer-name {{ $t("ui.my_bets") }}
    .footer-single.active.dropdown(v-if="whiteLabel && SPECIAL_EVENTS[2]")
      .footer-icon-wrap
        .footer-icon.worldcup
          a(href="javascript:void(0);" @click.prevent="openWorldCupMarket")
            img.custom-icon(src='images/worldcup.gif' alt='')
    
    router-link.footer-single(:class="{ 'active' : $route.name == 'highlight' }" to="/highlight")
      .footer-icon-wrap
        .footer-icon
          ThemeImage.custom-icon(src='images/light/footer-nav/tv.svg')
        .footer-name {{ $t("ui.video") }}
    .footer-single.dropdown.dropdown-full(:class="{ 'active' : ['account','message','contact_us','statement','result','settings','betting_rules','tnc'].includes($route.name) }")
      #btn-dd-account.footer-icon-wrap(data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
        .footer-icon
          ThemeImage.custom-icon(src='images/light/footer-nav/account.svg')
        .footer-name {{ $t("ui.my_account") }}
      .dropdown-menu.account-menu(aria-labelledby='btn-dd-account')
        ul
          li.d-item
            router-link(href="javascript:void(0);" to="/account" :class="$route.name == 'account' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-user
              span.text {{ $t("ui.my_account") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/message" :class="$route.name == 'message' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-envelope
              span.text {{ $t("ui.message") }}
          template(v-if="!['MMK','MMO'].includes(currency_code)")
            li.d-item(v-if="!whiteLabel && contact")
              router-link(href="javascript:void(0);" to="/contact_us" :class="$route.name == 'contact_us' ? 'active' : ''")
                span.icon
                  i.fa-solid.fa-phone-volume
                span.text {{ $t("ui.contact_us") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/statement" :class="$route.name == 'statement' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-file-invoice-dollar
              span.text {{ $t("ui.statement") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/sysparlay" :class="$route.name == 'sysparlay' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-file-invoice-dollar
              span.text {{ $t("ui.sysparlay") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/result" :class="$route.name == 'result' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-chart-bar
              span.text {{ $t("ui.result") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/parlaygenerator" :class="$route.name == 'parlaygenerator' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-random
              span.text {{ $t("ui.parlay_generator") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/settings" :class="$route.name == 'settings' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-cog
              span.text {{ $t("ui.settings") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/betting_rules" :class="$route.name == 'betting_rules' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-file-alt
              span.text {{ $t("ui.betting_rules") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/tnc" :class="$route.name == 'tnc' ? 'active' : ''")
              span.icon
                i.fa-solid.fa-tasks
              span.text {{ $t("ui.tnc") }}
          li.d-item(v-if="brand != 'FOTBET'")
            a(href="https://docs.google.com/forms/d/16N4aJg8nc2c3yqiAMG1byLhbmUnyfaG74_BABeo-2aY/viewform?edit_requested=true" target="_blank")
              span.icon
                i.fa-solid.fa-thumbs-up
              span.text {{ $t("ui.feedback") }}
        .btn-logout-wrap(v-if="!whiteLabel")
          a.btn-logout(href="javascript:void(0);" @click="logout()")
            span.icon
              i.fa-solid.fa-sign-out-alt
            span.text  {{ $t("ui.logout") }}
        .footer-group
          .footer-wrapper
            .footer-item.select-lang(data-bs-toggle='modal' data-bs-target='#changeLang')
              span.icon.lang-pic
                img(:src="'/images/lang/' + language +  '.svg?v=12'")
              span.text {{ $t("language." + language) }}
            .footer-item(v-if="!whiteLabel")
              a(:href="desktopUrl")
                span.icon
                  i.fa-solid.fa-desktop
                span.text {{ $t("ui.desktop_view") }}
            .footer-item(v-else)
              a(href='javascript:void(0);' @click="changeView('classic')")
                span.icon.lang-pic
                  img.mode-icon(src='images/light/sparkles.svg')
                span.text {{ $t("ui.classic_view") }}
            .footer-item(v-if="contact")
              a(href="https://www.facebook.com/WbetOfficial/?epa=SEARCH_BOX" target="_blank")
                span.icon
                  i.fa-brands.fa-facebook
                span.text {{ brand }}
            #themeToggle.footer-item(v-if="!whiteLabel" @click="toggleTheme")
              span.icon
                i.fa-solid(:class="currentTheme === 'light' ? 'fa-moon' : 'fa-sun'")
              span {{ currentTheme === 'light' ? $t("ui.dark") : $t("ui.light") }}

</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import xhr from "@/library/_xhr-menu";
import sync from "@/library/_sync-menu";
import calc from "@/library/_calculation";
import config from "@/config";
import { toggleTheme, getTheme } from "@/utils/theme.js";
import acc from '@/library/_xhr-account';

export default {
  data() {
    return {
      options: {},
      total_bet: 1,
      total_stake: 0,
      fold: 0,
      firstLoad: true,
      currentTheme: 'light',
      themeObserver: null,
      // SPECIAL_EVENTS: [0, 0, 0, 0, 0, 0, 0, 0]
    };
  },
  computed: {
    SPECIAL_EVENTS() {
      return [0, 0, this.wcMode ? 1 : 0, 0, 0, 0, 0, 0];
    },
    wcMode() {
      return config.wcMode;
    },
    vg1() {
      return config.vg1;
    },
    euroPageUrl() {
      return config.getEuroPageUrl();
    },
    contact() {
      return config.contact;
    },
    brand() {
      return config.brand;
    },
    esports2() {
      return config.esports2 == "1";
    },
    menuX() {
      return this.$store.getters.menuX;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    combo() {
      return this.$store.state.betparlay.combo;
    },
    comboKeys() {
      return Object.keys(this.$store.state.betparlay.combo);
    },
    comboOdds() {
      var results = {};
      var nn = 0;
      for (var n in this.comboKeys) {
        for (var m in this.combo[this.comboKeys[n]]) {
          nn = nn + 1;
          if (results[this.comboKeys[n]] == null) {
            results[this.comboKeys[n]] = [];
          }
          var multi = 1.0;
          var po = -1;
          for (var j in this.combo[this.comboKeys[n]][m]) {
            var test = this.$store.state.betparlay.data[this.combo[this.comboKeys[n]][m][j]];
            if (test != null) {
              multi = multi * parseFloat(test.val);
              var mpo = test.maxParlayPayout;
              if (po < 0 || po > mpo) po = mpo;
            }
          }
          // multi = multi.toFixed(3);
          results[this.comboKeys[n]].push([multi, po + nn]);
        }
      }
      return results;
    },
    betparlay() {
      return this.$store.state.betparlay;
    },
    betparlayCount() {
      if(this.menuX && this.mmoMode) {
        return Object.keys(this.$store.state.betparlaymmo.data).length;
      } else {
        return Object.keys(this.$store.state.betparlay.data).length;
      }
    },
    multi() {
      var result = 1;
      if(this.menuX && this.mmoMode) {
        for (var i = 0; i < this.betparlayCount; i++) {
          result = result * 2;
        }
      } else {
        // for (var n in this.betparlay) {
        //   result = result * parseFloat(this.betparlay[n].val);
        // }
        result = 0.0;
        if (this.comboOdds.hasOwnProperty(this.betparlayCount)) {
          for (var n in this.comboOdds[this.betparlayCount]) {
            result = result + this.comboOdds[this.betparlayCount][n][0];
          }
        }
      }

      var f = result ? parseFloat(calc.fm(result, false, 4)).toFixed(3) : 0;
      return f;
    },
    desktopUrl() {
      let domain = window.location.hostname;
      let sessionToken = this.$store.getters.sessionToken;
      return "https://" + domain.replace("mv2.", "dv2.") + "?&u=" + this.account_id + "&st=" + sessionToken;
    },
    menuList() {
      return this.$store.state.layout.menuList;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    last_login_time() {
      if (this.$store.getters.playerInfo) return this.$dayjs(this.$store.getters.playerInfo.last_login_time).format("MM/DD/YY hh:mm:ss A");
      return null;
    },
    wallet() {
      if (this.$store.getters.playerWallet) return this.$store.getters.playerWallet;
      return null;
    },
    balance() {
      return this.$store.getters.balance;
    },
    currency_code() {
      if (this.wallet["currency_code"]) {
        return this.wallet.currency_code;
      }
      return "-";
    },
    available_balance() {
      if (this.wallet) {
        return this.$numeral(this.balance).format("0,0.[00]");
      }
      return "-";
    },
    cash_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.cash_balance).format("0,0.[00]");
      }
      return "-";
    },
    frozen_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.frozen_balance).format("0,0.[00]");
      }
      return "-";
    },
    given_credit() {
      if (this.wallet) {
        return this.$numeral(this.wallet.credit_limit).format("0,0.[00]");
      }
      return "-";
    },
    selectedDays() {
      return this.$store.getters.selectedDays;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    language() {
      return this.$store.getters.language;
    }
  },
  watch: {
    language(newVal) {
      this.populateMenu();
    }
  },
  destroyed() {
    EventBus.$off("GET_BALANCE", this.populateMenu);
    clearInterval(this.populateMenu);
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  },
  mounted() {
    this.currentTheme = getTheme();
    this.populateMenu();
    setInterval(this.populateMenu, 15000);
    EventBus.$on("GET_BALANCE", this.populateMenu);
    
    // Watch for theme changes from other components
    const html = document.documentElement;
    this.themeObserver = new MutationObserver(() => {
      const theme = html.getAttribute('data-theme') || 'light';
      if (this.currentTheme !== theme) {
        this.currentTheme = theme;
      }
    });
    this.themeObserver.observe(html, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    showMe() {
      if(this.menuX && this.mmoMode) {
        if (EventBus.showParlayMMO) {
          EventBus.showParlayMMO();
        }
      } else {
        if (EventBus.showParlay) {
          EventBus.showParlay();
        }
      }
    },
    go(e) {
      this.$router.push(e).catch(err => {});
    },
    /** Same as sidebar World Cup link: setMenu0("event", "3", getEventDate(...)) */
    openWorldCupMarket() {
      this.$store.dispatch("layout/setSelectedMatch", null);
      if (EventBus.cancelParlay) EventBus.cancelParlay();
      if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
      this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
      $(".btn-parlay").removeClass("active");
      $(".btn-mmo-parlay").removeClass("active");

      const mi5 = {
        menuX: false,
        menuY: "3",
        menu0: "event",
        menu1: this.getEventDate("2026-06-11T12:00:00"),
        menu3: "hdpou",
        menu2: this.menu2
      };
      if (config.vg1.includes(parseInt(mi5.menu2, 10))) {
        mi5.menu2 = 1;
      }

      let changed = false;
      if (mi5.menuX !== this.menuX) changed = true;
      if (String(mi5.menuY) !== String(this.$store.state.layout.menuY)) changed = true;
      if (mi5.menu0 !== this.menu0) changed = true;
      if (mi5.menu1 !== this.menu1) changed = true;
      if (mi5.menu2 != this.menu2) changed = true;
      if (mi5.menu3 !== this.menu3) changed = true;

      if (changed) {
        this.setDays(parseInt(mi5.menu2, 10));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
      if (this.$route.path !== "/prematch") {
        this.$router.push("/prematch").catch(() => {});
      }
    },
    logout() {
      this.$helpers.logout();
    },
    getMenu(e) {
      if (!this.menuList) {
        return {};
      }

      if (!this.menuList.menu) {
        return {};
      }

      switch (e) {
        case "early":
          if (this.menuList.menu["1"]) return this.menuList.menu["1"];
          else return {};
        case "today":
          if (this.menuList.menu["2"]) return this.menuList.menu["2"];
          else return {};
        case "live":
          if (this.menuList.menu["3"]) return this.menuList.menu["3"];
          else return {};
        case "parlay":
          if (this.menuList.menu["4"]) return this.menuList.menu["4"];
          else return {};
        default:
          return {};
      }
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    hasSportMarket(marketId, sportId) {
      var menu = this.menuList && this.menuList.menu && this.menuList.menu[marketId];
      var item = menu && (menu[sportId] || menu[String(sportId)]);
      return !!(item && item.tn > 0);
    },
    // Footer sports open on the tab that actually has matches for that sport: live first, then today, then early
    selectFooterSport(sportId) {
      if (this.menu0 == "parlay") {
        this.setMenu2x("today", sportId);
        return;
      }
      // Same as sidebar setMenu2x(57): V-Games only render on all/today
      if (config.gamesList.includes(String(sportId))) {
        this.setMenu2x("today", sportId);
        return;
      }
      if (this.hasSportMarket("3", sportId)) {
        this.setMenu2x("live", sportId);
      } else if (this.hasSportMarket("2", sportId)) {
        this.setMenu2x("today", sportId);
      } else if (this.hasSportMarket("1", sportId)) {
        this.setMenu2x("early", sportId);
      } else {
        this.setMenu2x("today", sportId);
      }
    },
    setMenu2x(m, e) {
      // $(".btn-parlay").removeClass("active");
      this.$store.dispatch("layout/setSelectedMatch", null);
      // this.$store.dispatch("layout/resetSelectLeague"); 
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      switch (m) {
        case "live":
          mi5["menu1"] = "live";
          mi5["menu3"] = "hdpou";
          mi5["menu0"] = "live";
          // Honours the sport that was clicked; falls back to the current one when called without it
          mi5["menu2"] = parseInt(e != null ? e : this.menu2);
          var liveOptions = {};
          liveOptions[mi5["menu2"]] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: liveOptions });
          break;
        case "upcoming":
          $(".ddlive").dropdown("toggle");
          mi5["menu1"] = m;
          mi5["menu3"] = "hdpou";
          mi5["menu0"] = "upcoming";
          mi5["menu2"] = parseInt(this.menu2);
          for (var n in this.options) {
            this.options[n] = false;
          }
          this.options[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: this.options });
          break;
        default:
          if (this.menu0 == "parlay") {
            mi5["menu1"] = "parlay";
            mi5["menu3"] = "parlay";
            mi5["menu0"] = "parlay";
          } else {
            mi5["menu1"] = m;
            mi5["menu3"] = "hdpou";
            mi5["menu0"] = "all";
          }

          mi5["menu2"] = parseInt(e);
      }

      config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);

      var changed = false;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        // Prematch fetches on mount, so only the page already showing markets needs the event
        if (this.$route.name == "prematch") {
          EventBus.$emit("INVALIDATE", mi5);
        }
      }
      if(m == 'livenow') {
        this.$router.push("/highlight").catch(err => {});
      } else {
        this.$router.push("/prematch").catch(err => {});
      }
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
      }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    populateMenu(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          arguments: [this.$store.getters.language]
        };
        xhr.getMenu(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                var m = sync.decode(res.data);
                this.$store.dispatch("layout/setSports", { items: m["sports"], currency_code: this.currency_code });
                this.$store.dispatch("layout/setMenuList", m);
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                // if (callback) callback();
              }
            }

            var q = this.$route.query;
            if (q.vg == 1) {
              this.setMarbleRunView();
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              // if (callback) callback();
            }
          }
        );
      }
    },
    setMarbleRunView() {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = "today";
      mi5["menu2"] = 49;
      mi5["menu3"] = "hdpou";

      var options = {};
      options[mi5["menu2"]] = true;
      this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE");
      this.$router.push("/prematch");
    },
    getEventDate(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? "today" : "early";
    },
    getEventDate2(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? null : "orz";
    },
    toggleTheme() {
      const newTheme = toggleTheme();
      this.currentTheme = newTheme;
    },
    changeView(e) {
      let wloc = acc.changeView(e);
      window.location.href = wloc+ "?u=" + this.$store.getters.accountId + "&st=" + this.$store.getters.sessionToken;
    },
  }
};
</script>
